(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/extends', 'babel-runtime/core-js/object/assign', '../core/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/extends'), require('babel-runtime/core-js/object/assign'), require('../core/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.assign, global.convert);
    global.assign = mod.exports;
  }
})(this, function (exports, _extends2, _assign, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.assign = undefined;

  var _extends3 = _interopRequireDefault(_extends2);

  var _assign2 = _interopRequireDefault(_assign);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by an object assigning own enumerable string keyed properties of source objects to the destination object.<br />
   * Source objects are applied from left to right. Subsequent sources overwrite property assignments of previous sources.
   * @function
   * @memberof object
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...Object} [sources] The source objects.
   * @return {Object} Returns the updated object.
   * @example assign({ nested: { a: 1, b: 2 } }, 'nested', { b: 3, c: 4 }) // => { nested: { a:1, b: 3, c: 4 } }
   * @see {@link https://mdn.io/Object.prototype.assign|Object.prototype.assign} for more information.
   * @since 0.1.12
   */
  var assign = (0, _convert.convert)(function (obj) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return _assign2.default.apply(Object, [(0, _extends3.default)({}, obj)].concat(args));
  });

  exports.assign = assign;
});